export default __webpack_public_path__ + "static/media/logo.cd6d4654.png";